import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LunaCommonModule } from "../common/common.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Components
import { PaymentCheckoutComponent } from "./components/payment-checkout/payment-checkout.component";
import { PaymentResponseComponent } from "./components/payment-response/payment-response.component";
import { PaymentReportComponent } from './components/payment-report/payment-report.component';


// TESTER

// Services
import { PaymentService } from "./services/payment.service";
import { PaymentCalculatorService } from "./services/payment-calculator.service";
import { PaymentInvoiceComponent } from './components/payment-invoice/payment-invoice.component';
import { PaymentOpenItemsReportComponent } from "./components/payment-open-items-report/payment-open-items-report.component";
import { RequestPaymentAdjustmentComponent } from './components/request-payment-adjustment/request-payment-adjustment.component';
import { ApprovePaymentAdjustmentComponent } from './components/approve-payment-adjustment/approve-payment-adjustment.component';
import { AdjustmentRequestNotesComponent } from './components/adjustment-request-notes/adjustment-request-notes.component';
 

@NgModule({
    imports: [
        CommonModule,
        LunaCommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    providers: [
        PaymentService,
        PaymentCalculatorService
    ],
    declarations: [
        PaymentCheckoutComponent,
        PaymentResponseComponent,
        PaymentReportComponent,
        PaymentInvoiceComponent,
        PaymentOpenItemsReportComponent,
        RequestPaymentAdjustmentComponent,
        ApprovePaymentAdjustmentComponent,
        AdjustmentRequestNotesComponent
    ]
})
export class LunaPaymentsModule { }
